/* libs/oyan-ui/src/lib/features/sites/components/site-card/site-card.component.scss */
.site-card {
  font-size: 12px;
  line-height: 12px;
  background-color: #fff;
  word-break: break-all;
  word-wrap: break-word;
  box-shadow: var(--overview-box-shadow);
}
.site-card__item + .site-card__item {
  margin-top: 15px;
}
.site-card__details {
  position: relative;
}
.site-card__name {
  font-size: 20px;
  line-height: 20px;
  font-weight: 600;
}
.site-card__description {
  margin-top: 30px;
  white-space: break-spaces;
}
.site-card-col + .site-card-col {
  position: relative;
  padding: 30px 30px 15px;
}
.site-card-buttons {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
.site-card-content {
  margin-top: 30px;
}
.site-card-list + .site-card-list {
  padding-left: 15px;
  border-left: 1px solid #b0b0b0;
}
@media screen and (max-width: 959px) {
  .site-card-list + .site-card-list {
    margin-top: 30px;
    padding-left: 0;
    border-left: 0;
  }
}
/*# sourceMappingURL=site-card.component.css.map */
